module.exports = __webpack_public_path__ + "static/media/(000030).5639fe3d.jpg";